import { T } from '@tribeplatform/react-components/i18n'

import { AskAISettingsCard } from '../AskAISettingsCard.js'

export function AskAIRouter() {
  return <AskAISettingsCard />
}

export function AskAIBreadCrumb() {
  return <T id="Search.AskAI" defaultMessage="Ask AI" />
}
